import {Notification} from '@baidu/luffy-comp-notification';
export default Notification;
